import { useEffect, useState } from "react";
import arcBridge from "frontend/js/arcBridge";

function useLocationSearch(inputRef, variantIds = []) {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [userCoords, setUserCoords] = useState(null);
  const [hasManualSearch, setHasManualSearch] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const fetchStores = async ({ lat, lng, postcode = "", initialLoad = false }) => {
    const hasVariants = variantIds.length > 0;
    const requestParams = hasVariants
      ? {
          id: variantIds.join(","),
          ...(initialLoad ? {} : {
            postcode,
            delivery_lat: lat,
            delivery_lng: lng,
          }),
        }
      : {
          ...(initialLoad ? {} : {
            ...(postcode && { postcode }),
            ...(lat !== undefined && { delivery_lat: lat }),
            ...(lng !== undefined && { delivery_lng: lng }),
          }),
        };

    setLoading(true);

    try {
      let response;

      if (hasVariants) {
        response = await arcBridge.getClickAndCollectStore(requestParams);
        setStores(response);
      } else {
        response = await arcBridge.getLocations(requestParams);
        if (response?.stores?.length > 0 || initialLoad) {
          if (process.env.NODE_ENV === "development") {
            console.log("store response", response);
          }
          setStores(response?.stores || []);
        }
      }

      setHasSearched(true);
    } catch (error) {
      console.error("Error fetching stores:", error);
      setStores([]);
      setHasSearched(true);
    } finally {
      setLoading(false);
    }
  };

  const searchByQuery = (query, triggeredByAutocomplete = false) => {
    const trimmedQuery = query.trim();
    if (!trimmedQuery) {
      setHasManualSearch(false);
      fetchStores({ initialLoad: true });
      return;
    }

    if (process.env.NODE_ENV === "development") {
      console.log("Searching by query:", trimmedQuery);
    }

    if (!window.google?.maps) return;

    const geocoder = new window.google.maps.Geocoder();
    const options = {
      address: trimmedQuery,
      componentRestrictions: { country: "AU" }
    }

    geocoder.geocode(options, (results, status) => {
      if (process.env.NODE_ENV === "development") {
        console.log("Geocoder results:", results);
      }

      if (status === "OK" && results[0]) {
        const lat = results[0].geometry.location.lat();
        const lng = results[0].geometry.location.lng();
        const postcode =
          results[0].address_components?.find((c) =>
            c.types.includes("postal_code")
          )?.short_name || "";

        setUserCoords({ lat, lng });
        setHasManualSearch(true);
        if (!triggeredByAutocomplete) {
          fetchStores({ lat, lng, postcode });
        }
        setErrorMessage("");
      } else {
        console.error("Geocoding failed for query:", trimmedQuery, "Status:", status, "Results:", results);
        setStores([]);
        setHasSearched(true);
        setErrorMessage("We couldn't find a location for that address. Please try a nearby suburb or postcode.");
      }
    });
  };

  const handleLocationSearch = () => {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        const lat = coords.latitude;
        const lng = coords.longitude;
        setUserCoords({ lat, lng });
        setHasManualSearch(false);
        fetchStores({ lat, lng });
        setErrorMessage("");
      },
      (error) => {
        console.error("Geolocation error:", error);
        alert("We couldn't access your location. Please try again or enter a suburb.");
        setHasSearched(true);
        setErrorMessage("We couldn't access your location. Please try again or enter a suburb.");
      }
    );
  };


  // useEffect(() => {
  //   if (!window.google?.maps || !inputRef?.current) return;

  //   const autoCompleteInstance = new window.google.maps.places.Autocomplete(inputRef.current, {
  //     types: ["geocode"],
  //     componentRestrictions: { country: "AU" },
  //   });

  //   const listener = autoCompleteInstance.addListener("place_changed", () => {
  //     const place = autoCompleteInstance.getPlace();
  //     if (!place?.geometry) return;

  //     const lat = place.geometry.location.lat();
  //     const lng = place.geometry.location.lng();
  //     const postcode =
  //       place.address_components?.find((c) =>
  //         c.types.includes("postal_code")
  //       )?.short_name || "";

  //     setUserCoords({ lat, lng });
  //     setHasManualSearch(true);
  //     fetchStores({ lat, lng, postcode });
  //     setErrorMessage("");
  //   });

  //   return () => {
  //     window.google.maps.event.removeListener(listener);
  //   };
  // }, [inputRef]);

  return {
    handleLocationSearch,
    searchByQuery,
    fetchStores,
    stores,
    loading,
    hasSearched,
    userCoords,
    hasManualSearch,
    errorMessage,
  };
}

export default useLocationSearch;